import { isInstitutionalDocumentHistory, isInstitutionalActs } from '@urbanik/api-contracts';
export class InstitutionalDocumentError extends Error {
    status;
    constructor(status) {
        super(status === 409
            ? 'El acta cambió. Cierra y vuelve a abrir el panel.'
            : status === 403
                ? 'No tienes permiso documental en esta entidad.'
                : status === 413
                    ? 'El PDF supera 20 MB.'
                    : 'No se pudo procesar el documento.');
        this.status = status;
    }
}
const uuid = (v) => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(v);
async function request(base, org, actId, path, init, signal) {
    if (!uuid(org) || !uuid(actId))
        throw new InstitutionalDocumentError(400);
    let response;
    try {
        response = await fetch(base.replace(/\/$/, '') +
            '/identity/multi-review/organizations/' +
            org +
            '/governance/acts/' +
            actId +
            path, { ...init, credentials: 'include', cache: 'no-store', signal: signal ?? null });
    }
    catch (error) {
        if (signal?.aborted)
            throw error;
        throw new InstitutionalDocumentError(503);
    }
    if (!response.ok)
        throw new InstitutionalDocumentError(response.status);
    return response;
}
async function json(response) {
    try {
        return await response.json();
    }
    catch {
        throw new InstitutionalDocumentError(502);
    }
}
export async function getInstitutionalDocumentHistory(base, org, actId, signal) {
    const result = await json(await request(base, org, actId, '/documents', {}, signal));
    if (!isInstitutionalDocumentHistory(result, org, actId))
        throw new InstitutionalDocumentError(502);
    return result;
}
export async function uploadInstitutionalActDocument(base, org, actId, file, expectedVersion, reason, signal) {
    if (file.size > 20971520)
        throw new InstitutionalDocumentError(413);
    if (typeof reason !== 'string' || reason.trim().length < 5 || reason.trim().length > 500)
        throw new InstitutionalDocumentError(400);
    if (file.size < 5)
        throw new InstitutionalDocumentError(400);
    const response = await request(base, org, actId, '/document', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/pdf',
            'X-Urbanik-Review': '1',
            'X-Urbanik-Reason': encodeURIComponent(reason.trim()),
            'X-Urbanik-File-Name': encodeURIComponent(file.name),
            'X-Urbanik-Expected-Version': String(expectedVersion),
        },
        body: file,
    }, signal);
    const result = await json(response);
    if (!isInstitutionalActs(result, org) ||
        result.items.length !== 1 ||
        result.items[0].id !== actId ||
        result.items[0].version !== expectedVersion + 1 ||
        !result.items[0].hasDocument ||
        result.items[0].documentStatus !== 'approved')
        throw new InstitutionalDocumentError(502);
    return result.items[0];
}
export async function downloadInstitutionalDocumentVersion(base, org, actId, id, signal) {
    if (!uuid(id))
        throw new InstitutionalDocumentError(400);
    const response = await request(base, org, actId, '/documents/' + id, {}, signal);
    if (response.headers.get('x-urbanik-organization') !== org ||
        response.headers.get('content-type')?.split(';')[0] !== 'application/pdf')
        throw new InstitutionalDocumentError(502);
    return response.blob();
}
